import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
export var ExpandOutlineSVG = function ExpandOutlineSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M19.41,1.54l9.83-.1a1.13,1.13,0,0,1,.79.35,1.08,1.08,0,0,1,.34.78l-.1,9.87a1.07,1.07,0,0,1-1.06,1.06h0a1,1,0,0,1-1.05-1.05L28.24,5l-8.81,8.84A1,1,0,1,1,18,12.4l8.83-8.82-7.45.08a1,1,0,0,1-1.05-1.05h0A1.08,1.08,0,0,1,19.41,1.54ZM13.66,29.39h0a1,1,0,0,0-1.05-1.05l-7.45.08L14,19.6a1,1,0,1,0-1.42-1.42L3.76,27l.08-7.47a1,1,0,0,0-1-1.05h0a1.07,1.07,0,0,0-1.06,1.06l-.1,9.87a1.08,1.08,0,0,0,.34.78,1.13,1.13,0,0,0,.79.35l9.83-.1A1.08,1.08,0,0,0,13.66,29.39Z"
  }));
};
ExpandOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(ExpandOutlineSVG);